import {ReactNode} from 'react';
import {useLocalStorageValue} from '@react-hookz/web';
import {clsx} from 'clsx';
import {InitData} from '../../../common/init-data/init-data';
import {BigFetchWithCleanPosition} from '../../../envisia/workflow/fetch/box/fetch-box.model';
import {FetchArticleUsageStateLabel} from '../article-usage-state/fetch-article-usage-state-label';
import {FETCH_STATUS} from '../fetch-status.model';

interface Props {
  fetch: BigFetchWithCleanPosition;
  children?: ReactNode;
}

export function FetchBoxHeader(props: Props) {
  const initData = useLocalStorageValue<InitData>('data');
  const fetchStatus = initData.value?.fetch_status[props.fetch.status];
  const isDelivered = props.fetch.status === FETCH_STATUS.DELIVERY;

  return <div className={clsx('flex pt-2! pb-2!', fetchStatus && `alert-${fetchStatus.label}`)}>
    <div className="col-sm-9">
      <h4 className="inline-block p-2! mb-0!">
        ABRUF {props.fetch.ordering}&nbsp;
        {props.fetch.is_complaint && <span className="label label-danger">Reklamation</span>}
        &nbsp;(#{props.fetch.id}) - {isDelivered ? 'Geliefert' : fetchStatus?.name}
        {isDelivered && props.fetch.delivery_obj?.invoice_lock && <>
          &nbsp;<span className="label label-danger">Gesperrt für Rechnungen</span>
        </>}
      </h4>
      <div className="inline-block">
        {props.children}
      </div>
      <FetchArticleUsageStateLabel fetchState={props.fetch.status}
                                   articleUsageState={props.fetch.article_usage_state}/>
    </div>
    <div className="col-sm-3">
      <div className="pull-right mt-1.5">
        {props.fetch.earliest_delivery && <span className="label label-danger">Frühestmöglicher Liefertermin</span>}
        &nbsp;|&nbsp;
        <strong>Liefertermin: {props.fetch.delivery}</strong>
      </div>
    </div>
  </div>;
}
